import styled from 'styled-components';

export const CompleteData = styled.div`
  background: #cde9e1;
  /* alert - green */

  border: 1px solid #01cc9d;
  border-radius: 15px;

  .icon-information {
    display: flex;
    align-items: center;
    padding: 0% 3%;
  }

  .text-box {
    margin: 1% 0%;
  }
  .text-extra {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

    /* White */

    color: #ffffff;
  }

  .box-fill {
    display: flex;
  }

  .box-button-fill {
    display: flex;
    justify-content: center;
    @media (max-width: 1199px) {
      justify-content: flex-start;
      margin-left: -1%;
    }
    @media (max-width: 408px) {
      margin-left: -10%;
    }
    @media (max-width: 322px) {
      margin-left: -15%;
    }
  }

  .button-fill {
    border: 0px;
    margin-right: 3%;
    color: #ffffff;
    /* green */

    background: #079269;
    border-radius: 26px;
  }
`;
